import styled from 'styled-components';

export const Content = styled.div`
    position: relative;
    overflow: hidden;
    display: flex;
    width: 100%;
    flex-grow: 1;
`;
